/**
 * Asynchronously loads the AgentActivity
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "AgentActivity" */ './index'),
  loading: () => null,
});
